import { ProductCategoryWarranty } from '@lambda/apis/src/category/types';
import { formatWarrantyInfo } from '@/lib/warranty';
import { NON_TECH_CATEGORIES } from '@/settings/configs';
import trustpilotFullStarBlack from '@/public/images/banner/trustpilot_full_star_black.svg';
import trustpilotHalfStarBlack from '@/public/images/banner/trustpilot_half_star_black.svg';
import trustpilotFullStar from '@/public/images/banner/trustpilot_full_star.svg';
import trustpilotHalfStar from '@/public/images/banner/trustpilot_half_star.svg';
import settings from '@/settings/index';

export const generateWarrantyLabel = (
  category: string | undefined,
  categoryWarrantyInfo: ProductCategoryWarranty | null,
) => {
  const isTechCollection = !NON_TECH_CATEGORIES.includes(category ?? '');

  if (!isTechCollection) {
    return 'Fast & Free Shipping';
  }

  if (settings.store === 'quista') {
    return 'Up to 12 Months Warranty';
  }

  const formattedWarrantyInfo = formatWarrantyInfo(categoryWarrantyInfo);

  if (categoryWarrantyInfo?.eligible) {
    return `${formattedWarrantyInfo} Warranty`;
  }

  // TODO deprecate store specific warranty
  if (settings.warranty_month === 12) {
    return '1 Year Warranty';
  }

  return `${settings.warranty_month} Month Warranty`;
};

export const getStars = ({
  isHealthBeautyCollection,
}: {
  isHealthBeautyCollection: boolean;
}) => {
  if (isHealthBeautyCollection) {
    return {
      fullStar: trustpilotFullStarBlack,
      halfStar: trustpilotHalfStarBlack,
    };
  }

  return {
    fullStar: trustpilotFullStar,
    halfStar: trustpilotHalfStar,
  };
};
